import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loadAutoRefinance } from 'actions/actions.actions';
import { getAutoRefinance } from 'helpers/autoOffer.helpers';

export const useGoals = ({ creditInfo, userInfo }) => {
  const { autoRefinance, autoRefinanceLoading } = useSelector(state => ({
    autoRefinance: state?.actions?.autoRefinance,
    autoRefinanceLoading: state?.actions?.autoRefinanceLoading,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    if (!autoRefinance && !autoRefinanceLoading && userInfo && creditInfo) {
      dispatch(loadAutoRefinance(creditInfo, userInfo));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, creditInfo]);

  const autoRefinanceInfo = () => {
    return getAutoRefinance(autoRefinance, creditInfo);
  };

  return {
    autoRefinanceLoading,
    autoRefinanceInfo,
  };
};
